import axios from "axios";
export function standardFunctions() {
    let dpi = 300;
    function mmToPx(input) {
        return (input * dpi) / 25.4;
    }
    return {
        mmToPx
    };
}
export function loadConfigs(id) {
    return axios.post(route('configurator.configs.load'), {
        id: id,
    })
        .then(function (response) {
        return response.data;
    })
        .catch(function (error) {
        console.log(error);
    });
}
export function loadTenantConfigs(key) {
    return axios.post(route('configurator.tenants.configs.load'), {
        key: key,
    })
        .then(function (response) {
        return response.data;
    })
        .catch(function (error) {
        console.log(error);
    });
}
